/**
 * Returns true when the survey config opts into offline mode (has a truthy `offline` block).
 * Used to gate service worker registration: only field/offline surveys should register the SW.
 */
export function shouldRegisterServiceWorker(config: object | null | undefined): boolean {
  return !!((config as Record<string, unknown>)?.offline);
}
